<template>
  <div>
    <voxy-dropdown
      :class="['teacher-status-filter', isActive && 'teacher-status-filter_active']"
      ref="dropdown"
      menu-alignment="right"
      @on-open="isOpen = true"
      @on-close="isOpen = false"
    >
      <span slot="button" class="teacher-status-filter__icon">
        <font-awesome-icon :icon="['fas', 'user']" />
      </span>
      <div class="teacher-status-filter__dropdown">
        <h4 class="teacher-status-filter__dropdown__text">Teacher status</h4>
        <div class="teacher-status-filter__dropdown__content">
          <label
            v-for="option in options"
            :key="option.value"
            :class="['voxy-radio', isChecked(option) && 'voxy-radio_checked']"
          >
            <span class="voxy-radio__box">
              <input type="radio" class="voxy-radio__control" v-model="model" :value="option.value" />
            </span>
            <span class="voxy-radio__label">{{ option.name }}</span>
          </label>
        </div>
      </div>
    </voxy-dropdown>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { VoxyDropdown } from '@voxy-team/vue-voxy';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

export default {
  name: 'TeacherStatusFilter',

  components: {
    VoxyDropdown,
    FontAwesomeIcon,
  },

  data() {
    return {
      isOpen: false,
      options: [
        {
          name: 'All',
          value: null,
        },
        {
          name: 'Active',
          value: true,
        },
        {
          name: 'Inactive',
          value: false,
        },
      ],
    };
  },

  computed: {
    ...mapState('manageTeachers', ['active']),

    hasValue() {
      return this.active !== null;
    },

    isActive() {
      return this.isOpen || this.hasValue;
    },

    model: {
      get() {
        return this.active;
      },
      set(value) {
        this.setActive(value);
      },
    },
  },

  methods: {
    ...mapActions('manageTeachers', {
      setActive: 'SEARCH_BY_ACTIVE',
    }),

    isChecked(option) {
      return this.model === option.value;
    },

    close() {
      if (this.$refs.dropdown) {
        this.$refs.dropdown.close();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~styles/tools/variables';

.teacher-status-filter {
  &__icon {
    font-size: 21px;
    display: inline-flex;
    width: 1.5rem;
    justify-content: center;
    align-items: center;

    .teacher-status-filter_active & {
      color: $default-blue;
    }
  }

  &__dropdown {
    min-width: 230px;
    padding: 15px 10px 8px;
    box-shadow: 0 5px 10px rgba(0, 0, 0, 0.25);
    background-color: #515151;
    border-radius: 5px;

    &__text {
      font-size: 12px;
      font-weight: 300;
      margin: 0 0 0.8275rem;
      text-transform: uppercase;
      letter-spacing: 1px;
    }

    &__content {
      display: flex;
      gap: 12px;
    }
  }

  .voxy-radio {
    margin-bottom: 13px;
    cursor: pointer;

    &__box {
      width: 14px;
      height: 14px;
      margin-right: 6px;
      border-color: white;

      &::before {
        top: 2px;
        right: 2px;
        bottom: 2px;
        left: 2px;
      }
    }

    &__control {
      position: absolute;
      opacity: 0;
      cursor: pointer;
    }

    &__label {
      font-weight: 500;
      font-size: 13px;
    }
  }
}
</style>
